import { PmsStatusEnum } from "src/app/settings/interfaces/PmsStatusEnum";

// represents the different types of integrations available
export enum IntegrationTypeEnum {
  LibertyRx,
  PioneerRx,
  FrameworkLTC
}

// used to display the list of available integrations
export interface IIntegration {
  id: string;
  name: string;
}

// represents an integration applied to a pharmacy
export interface IIntegrationConfiguration {
  id?: string | null;
  integrationType: IntegrationTypeEnum | null;
  apiKey: string;
  pharmacyId: string;
  isActive: boolean;
  status?: PmsStatusEnum
}
